import { Component, Input } from '@angular/core';
import { DxDropDownButtonModule } from 'devextreme-angular/ui/drop-down-button';

@Component({
  selector: 'dk-dash-card-menu',
  templateUrl: './dash-card-menu.component.html',
  styleUrls: ['./dash-card-menu.component.scss'],
  standalone: true,
  imports: [DxDropDownButtonModule],
})
export class DashCardMenuComponent {
  @Input() items: Array<{ text: string }>;
  @Input() visible = true;

  constructor() {

  }
}
